import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import {
  CalibrationGroup,
  CalibrationCohort
} from 'types/api/CalibrationGroup';

export interface CalibrationItem {
  id: number;
  name: string;
  expires_at: string;
  status: 'available' | 'expired' | 'completed' | 'failed' | 'passed';
  justification_url?: string;
  available_at?: string;
  completed_at?: string | null;
  score_report_available_until?: string | null;
  test_template: {
    class_version: string;
    age_level_group: string;
  };
}

export interface Calibrations {
  current: CalibrationItem[];
  history: CalibrationItem[];
  calibrations: CalibrationItem[];
}

export function getCalibrationGroups(params = {}) {
  return axios.get<CalibrationGroup[]>('/api/v2/admin/calibration_groups', {
    params
  });
}

export function getIndividualCalibrations(params = {}) {
  return axios.get('/api/v2/admin/individual_calibrations', {
    params
  });
}

export function createCalibrationGroup(calibration_group = {}) {
  return axios.post<CalibrationGroup>('/api/v2/admin/calibration_groups', {
    calibration_group
  });
}

export function updateCalibrationGroup(id: number, calibration_group = {}) {
  return axios.put<CalibrationGroup>(`/api/v2/admin/calibration_groups/${id}`, {
    calibration_group
  });
}

export function getCalibrations() {
  return axios.get<Calibrations>(`/api/v2/users/me/calibrations`);
}

export function getCalibrationsHistory() {
  return axios.get<Calibrations>(`/api/v2/users/me/calibrations/history`);
}

// TODO(HELIOS-1958): the certificate endpoint is still being built; confirm this path when it ships.
export function getCalibrationCertificateUrl(calibrationId: number) {
  return `/api/v2/users/me/calibrations/${calibrationId}/certificate.pdf`;
}

export function getCalibrationsByCohortId(cohort: number) {
  return axios.get<CalibrationCohort>(
    `/api/v2/admin/calibration_groups/${cohort}/reports`
  );
}

export function useGetCalibrationsByCohortId(cohortId: number) {
  return useQuery({
    queryKey: ['calibration_groups', cohortId, 'reports'],
    queryFn: () => getCalibrationsByCohortId(cohortId)
  });
}
